<template>
    <div class="updateSiteAddress modal fade" tabindex="-1" aria-hidden="false"
        v-if="this.$store.state.meters.activeService">
        <div class="modal-dialog modal-full" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-8 col-sm-5 col-lg-5 my-auto">
                                <h5 class="modal-title">Update Site Address</h5>
                            </div>
                            <div class="col-4 col-sm-7 my-auto">
                                <div class>
                                    <a class="close">
                                        <i class="far fa-times-circle fa-2x" data-dismiss="modal"
                                            id="closeUpdateSiteAddress" aria-label="Close"
                                            @click="resetSiteAddress()"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="h-100">
                                            <b-card class="w-100">
                                                <div class="row">
                                                    <div class="col-12 text-center">
                                                        <switches v-model="isAdvancedAddress" type-bold="true"
                                                            theme="bootstrap" color="success" text-enabled="Advanced"
                                                            text-disabled="Simple"></switches>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="isAdvancedAddress">
                                                    <div class="col-12 mt-2">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Sub Building Name:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.SubBuildingName"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.SubBuildingName.$error }"
                                                                    rows="2">
                                                                </b-textarea>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.SubBuildingName.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.SubBuildingName.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Building Name:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.BuildingName"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.BuildingName.$error }"
                                                                    rows="2">
                                                                </b-textarea>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.BuildingName.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.BuildingName.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Building Number:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-input v-model="siteAddress.BuildingNumber"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.BuildingNumber.$error }">
                                                                </b-input>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.BuildingNumber.numeric">
                                                                    Please provide a numerical value.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Dependent Thoroughfare:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.DependentThoroughfare"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.DependentThoroughfare.$error }"
                                                                    rows="2">
                                                                </b-textarea>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.DependentThoroughfare.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.DependentThoroughfare.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Thoroughfare:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.Thoroughfare"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.Thoroughfare.$error }"
                                                                    rows="2">
                                                                </b-textarea>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.Thoroughfare.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.Thoroughfare.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Double Dependent Locality:
                                                                </p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea
                                                                    v-model="siteAddress.DoubleDependentLocality"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.DoubleDependentLocality.$error }"
                                                                    rows="2">
                                                                </b-textarea>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.DoubleDependentLocality.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.DoubleDependentLocality.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Dependent Locality:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.DependentLocality"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.DependentLocality.$error }"
                                                                    rows="2">
                                                                </b-textarea>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.DependentLocality.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.DependentLocality.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row" v-if="!isAdvancedAddress">
                                                    <div class="col-12 mt-2">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Line 1:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.Line1"
                                                                    class="form-control z-depth-1" rows="2">
                                                                </b-textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Line 2:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.Line2"
                                                                    class="form-control z-depth-1" rows="2">
                                                                </b-textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Line 3:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.Line3"
                                                                    class="form-control z-depth-1" rows="2">
                                                                </b-textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Line 4:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.Line4"
                                                                    class="form-control z-depth-1" rows="2">
                                                                </b-textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">PO Box:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-textarea v-model="siteAddress.PoBox"
                                                                    class="form-control z-depth-1" rows="2">
                                                                </b-textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Town:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-input v-model="siteAddress.Town"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.Town.$error }">
                                                                </b-input>
                                                                <div v-if="submitStatus == 'VALIDATING' && !$v.siteAddress.Town.required"
                                                                    class="invalid-feedback">Please provide a town.
                                                                </div>
                                                                <div class="invalid-feedback"
                                                                    v-if="!$v.siteAddress.Town.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.Town.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">County:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-input v-model="siteAddress.County"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.County.$error }">
                                                                    >
                                                                </b-input>
                                                                <div class="invalid-feedback"
                                                                    v-if="submitStatus == 'VALIDATING' && !$v.siteAddress.County.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.County.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="p-1 bg-white">
                                                            <div class="d-inline-block left align-top">
                                                                <p class="font-weight-bold">Postcode:</p>
                                                            </div>
                                                            <div class="d-inline-block right">
                                                                <b-input v-model="siteAddress.Postcode"
                                                                    class="form-control z-depth-1"
                                                                    :class="{ 'is-invalid': submitStatus == 'VALIDATING' && $v.siteAddress.Postcode.$error }">
                                                                </b-input>
                                                                <div v-if="submitStatus == 'VALIDATING' && !$v.siteAddress.Postcode.required"
                                                                    class="invalid-feedback">Please provide a postcode.
                                                                </div>
                                                                <div class="invalid-feedback"
                                                                    v-if="submitStatus == 'VALIDATING' && !$v.siteAddress.Postcode.minLength">
                                                                    Postcode must contain at least
                                                                    {{$v.siteAddress.Postcode.$params.minLength.min}}
                                                                    characters.</div>
                                                                <div class="invalid-feedback"
                                                                    v-if="submitStatus == 'VALIDATING' && !$v.siteAddress.Postcode.maxLength">
                                                                    Exceeded character limit of
                                                                    {{$v.siteAddress.Postcode.$params.maxLength.max}}.
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mt-2 mt-md-0">
                                        <div class="h-100">
                                            <b-card no-body class="w-100">
                                                <b-row class="p-4">
                                                    <b-col sm="6">
                                                        <ul class="list-group">
                                                            <li class="list-group-item font-weight-bold"
                                                                v-for="(line, index) in addressPreview" :key="index">
                                                                {{line}}
                                                            </li>
                                                        </ul>
                                                    </b-col>
                                                </b-row>
                                            </b-card>
                                            <div class="row">
                                                <div class="col-12">
                                                  <p v-if="activeServiceType === 'Gas'" class="my-4 text-center text-danger font-weight-bold">
                                                    To inform the industry about changes, please email your shipper with the details.
                                                  </p>
                                                  <p v-else class="my-4 text-center text-danger font-weight-bold">
                                                    Please follow the industry standard process to report these changes.
                                                  </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="float-right float-right mt-0 mt-md-auto">
                        <b-btn :disabled="submitStatus == 'PENDING'" class="btn btn-hc mr-1"
                            @click="resetSiteAddress()">Cancel</b-btn>
                        <b-btn @click="saveChanges()" :disabled="submitStatus == 'PENDING'" class="btn btn-hc ml-1">
                            Save
                            Changes
                        </b-btn>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      submitStatus: null,
    };
  },
  validations() {
    return {
      siteAddress: {
        BuildingName: {
          maxLength: maxLength(50),
        },
        SubBuildingName: {
          maxLength: maxLength(30),
        },
        BuildingNumber: {
          numeric,
        },
        DependentThoroughfare: {
          maxLength: maxLength(40),
        },
        Thoroughfare: {
          maxLength: maxLength(40),
        },
        DoubleDependentLocality: {
          maxLength: maxLength(40),
        },
        DependentLocality: {
          maxLength: maxLength(40),
        },
        Town: {
          required,
          maxLength: maxLength(40),
        },
        County: {
          maxLength: maxLength(40),
        },
        Postcode: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(8),
        },
      },
    };
  },
  computed: {
    isAdvancedAddress: {
      get() {
        return this.$store.state.meters.isAdvancedAddress;
      },
      set(bool) {
        this.$store.commit("updateAddressType", bool);
      },
    },
    addressPreview() {
      var addressLines = [];

      if (!this.isAdvancedAddress) {
        if (
          this.siteAddress.Line1 ||
          this.siteAddress.Line1 ||
          this.siteAddress.Line1 ||
          this.siteAddress.Line1
        ) {
          if (this.siteAddress.Line1) {
            addressLines.push(this.siteAddress.Line1);
          }

          if (this.siteAddress.Line2) {
            addressLines.push(this.siteAddress.Line2);
          }

          if (this.siteAddress.Line3) {
            addressLines.push(this.siteAddress.Line3);
          }

          if (this.siteAddress.Line4) {
            addressLines.push(this.siteAddress.Line4);
          }
        } else if (this.siteAddress.PoBox) {
          addressLines.push(`PO Box ${this.siteAddress.PoBox}`);
        }
      } else {
        if (this.siteAddress.SubBuildingName) {
          addressLines.push(this.siteAddress.SubBuildingName);
        }

        if (this.siteAddress.BuildingName) {
          addressLines.push(this.siteAddress.BuildingName);
        }

        if (this.siteAddress.DependentThoroughfare) {
          addressLines.push(
            this.siteAddress.BuildingNumber
              ? `${this.siteAddress.BuildingNumber} ${
                  this.siteAddress.DependentThoroughfare
                }`
              : this.DependentThoroughfare
          );
          addressLines.push(this.siteAddress.Thoroughfare);
        } else if (this.siteAddress.Thoroughfare) {
          addressLines.push(
            this.siteAddress.BuildingNumber
              ? `${this.siteAddress.BuildingNumber} ${
                  this.siteAddress.Thoroughfare
                }`
              : this.Thoroughfare
          );
        }

        if (this.siteAddress.DoubleDependentLocality) {
          addressLines.push(this.siteAddress.DoubleDependentLocality);
        }

        if (this.siteAddress.DependentLocality) {
          addressLines.push(this.siteAddress.DependentLocality);
        }
      }

      if (this.siteAddress.Town) {
        addressLines.push(this.siteAddress.Town.toUpperCase());
      }

      if (this.siteAddress.County) {
        addressLines.push(this.siteAddress.County);
      }

      if (this.siteAddress.Postcode) {
        addressLines.push(this.siteAddress.Postcode);
      }

      return addressLines;
    },
    siteAddress() {
      return this.$store.state.meters.updateableSiteAddress;
    },
    activeService() {
      return this.$store.state.meters.activeService;
    },
    activeServiceType() {
      return this.$store.state.meters.activeService.Service.ServiceType;
    }
  },
  methods: {
    resetSiteAddress() {
      this.$store.commit("resetSiteAddress");
      document.getElementById("closeUpdateSiteAddress").click();
    },
    saveChanges() {
      this.submitStatus = "VALIDATING";
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitStatus = "PENDING";
        var address = !this.isAdvancedAddress
          ? {
              Line1: this.siteAddress.Line1,
              Line2: this.siteAddress.Line2,
              Line3: this.siteAddress.Line3,
              Line4: this.siteAddress.Line4,
              PoBox: this.siteAddress.PoBox,
              Town: this.siteAddress.Town,
              County: this.siteAddress.County,
              Postcode: this.siteAddress.Postcode,
              SubBuildingName: null,
              BuildingName: null,
              BuildingNumber: null,
              DependentThoroughfare: null,
              Thoroughfare: null,
              DoubleDependentLocality: null,
              DependentLocality: null,
            }
          : {
              SubBuildingName: this.siteAddress.SubBuildingName,
              BuildingName: this.siteAddress.BuildingName,
              BuildingNumber: this.siteAddress.BuildingNumber,
              DependentThoroughfare: this.siteAddress.DependentThoroughfare,
              Thoroughfare: this.siteAddress.Thoroughfare,
              DoubleDependentLocality: this.siteAddress.DoubleDependentLocality,
              DependentLocality: this.siteAddress.DependentLocality,
              Town: this.siteAddress.Town,
              County: this.siteAddress.County,
              Postcode: this.siteAddress.Postcode,
              Line1: null,
              Line2: null,
              Line3: null,
              Line4: null,
              PoBox: null,
            };
        this.$http
          .put(
            "https://" +
              Vue.config.honeycomb.contractbot.domain +
              "/api/v1/Sites/" +
              this.activeService.Site.Id,
            {
              Id: this.activeService.Site.Id,
              Address: address,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.activeService.Site = response.data;
            this.submitStatus = "OK";
            document.getElementById("closeUpdateSiteAddress").click();
            this.$snotify.success(`Success! Site address updated.`);
          })
          .catch((error) => {
            // Error
            this.submitStatus = "ERROR";
            this.editMode = false;
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              if (error.response.data.MoreInformation.length > 0) {
                error.response.data.MoreInformation.forEach((e) => {
                  this.$snotify.error(`${e.Error}`, {
                    timeout: 0,
                    closeOnClick: true,
                  });
                });
              } else {
                this.$snotify.error(`${error.response.data.UserDescription}`, {
                  timeout: 0,
                  closeOnClick: true,
                });
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              this.$snotify.error(`No response recieved.`, {
                timeout: 0,
                closeOnClick: true,
              });
            } else {
              // Something happened in setting up the request that triggered an Error
              this.$snotify.error(`${error.message}`, {
                timeout: 0,
                closeOnClick: true,
              });
            }
          });
      }
    },
  },
};
</script>
